<div fxFlexFill fxLayout="column">
    <span class="header" fxLayout="row" fxLayoutAlign="end end" ngStyle.xs="font-size:20px">
        <a class="close regular" (click)="close()">Close</a></span>
    <div fxLayout="column">
        <div fxLayout="row">
            <img alt="QR" width="100%" height="100%" [src]="'data:image/jpeg;base64,'+ data.qrCode" />
        </div>
        <div *ngIf="false" fxLayout="row" fxLayoutAlign="end end">
            <a dir="auto" class="download-file textmedium bold" (click)="downloadQRCode(data.qrCode)" target="_blank">
                {{'download_qr_code' | transloco}}
            </a>
        </div>
    </div>
</div>
